module.exports = __webpack_public_path__ + "img/gate_ready_badge.cab7bc2.svg";